module.exports = __webpack_public_path__ + "static/img/xiexie.38c2a1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xiexie.jpg
// module id = GT1c
// module chunks = 1